import runPlaybook from './run-playbook';
import getPlaybook from './get-playbook';
import listPlaybooks from './list-playbooks';
import mcpServer from './mcp';
import login from './login';
import testAction from './test-action';
import fetchTeleportContext from './fetch-teleport-context';
import getAlert from './get-alert';
import ui from './ui';

export default {
  runPlaybook,
  getPlaybook,
  listPlaybooks,
  mcpServer,
  login,
  testAction,
  fetchTeleportContext,
  getAlert,
  ui,
};
